import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import { IAtendimentoCliente } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { AtendimentoPorProdutosController } from "../../../Controllers/AssistenciaTecnica/Atendimento/AtendimentoPorProduto/AtendimentoPorProdutoController";
import SpinnerComponent from "../../Loding/Spinner";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import { Tooltip } from "react-bootstrap";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";

interface IAtendimentoPorProdutoProps {
    idProduto: number;
}

function AtendimentosPorProdutoModal(props: IAtendimentoPorProdutoProps) {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });

    const { ID_CASO } = useAtendimentoPage();

    const {
        value: lstAtendimentosPorProdutos,
        loading: lstAtendimentosPorProdutosLoading,
    } = useAsyncEffect(async () => {
        const res = await AtendimentoPorProdutosController(
            props.idProduto,
            PageFilter.page
        );

        return res;
    }, [PageFilter]);

    const totalPaginas = lstAtendimentosPorProdutos?.NR_PAGINAS || 1;

    const atendimentoColumns: Array<ColumnDescription<IAtendimentoCliente>> = [
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            Ver Atendimento
                        </Tooltip>
                    }
                >
                    <Link
                        hidden={row.ID_CASO === ID_CASO}
                        to={ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK(
                            row.ID_CASO
                        )}
                        className="m-2 btn btn-icon btn-outline-info"
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </Link>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "ID_CASO",
            text: "Protocolo",
        },
        {
            dataField: "DS_TIPO_CASO",
            text: "Módulo",
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO",
            text: "Categoria",
        },
        {
            dataField: "DS_ETAPA",
            text: "Etapa",
        },
        {
            dataField: "DS_CONTATO",
            text: "Contato",
        },
    ];

    return (
        <>
            {
                <>
                    {lstAtendimentosPorProdutos ? (
                        <Table
                            columns={atendimentoColumns}
                            data={
                                lstAtendimentosPorProdutos.listaCasoPorProduto
                            }
                            keyField="ID_CASO"
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            remote={{ pagination: true }}
                            totalPages={totalPaginas}
                            loading={lstAtendimentosPorProdutosLoading}
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Atendimento encontrado
                                </div>
                            )}
                            noHover
                            noSearch
                            bordered={false}
                            defaultStyle={{ align: "center", classes: "p-2" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            center={true}
                        />
                    ) : (
                        <SpinnerComponent />
                    )}
                </>
            }
        </>
    );
}

export default AtendimentosPorProdutoModal;
